<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div *ngIf="VariableParametrica.nombre == 'Superintendencia'" class="card-header" style="background-color: #be0c4d;">
      <h4 style="color: white;">Superintendencia</h4>
    </div>
    <div *ngIf="VariableParametrica.nombre == 'Tipo Entidad'" class="card-header" style="background-color: #be0c4d;">
      <h4 style="color: white;">Tipo Entidad</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-auto">
          <a type="a" class="btn btn-secondary" (click)="Regresar()">Volver</a>
        </div>
        <div class="col-auto">
          <a type="a" class="btn btn-primary" (click)="NuevaSuperintendencia()" style="color: white;">Nuevo</a>
        </div>
      </div>
      <div class="container">
        <form>
          <div class="col-7">
            <div class="row">
              <div class="col-4">
                <div><label><b>Código superintendencia: </b></label></div>
                <div><input class="form-control" name="codigo" [formControl]="NuevaSuperCod"></div>
              </div>
              <div class="col-8">
                <div><label><b>Nombre superintendencia: </b></label></div>
                <div><input class="form-control" name="nombre" [formControl]="NuevaSuperNom"></div>
              </div>
            </div>
            <br>
            <div class="row justify-content-md-center">
              <button type="button" class="btn btn-primary col-2" (click)="Guardar()" [disabled]="!NuevaSuper || (NuevaSuperNom.hasError('required')||NuevaSuperCod.hasError('required'))">Guardar</button>
            </div>
          </div>
        </form>
      </div>
      <br>
      <div class="container-fluid overflow-scroll" style="align-content: center;">
        <table class="table table-bordered">
          <thead>
            <th>Codigo</th>
            <th>Nombre</th>
            <th>Editar</th>
          </thead>
          <tbody>
            <tr *ngFor="let s of SuperinList | paginate:{ itemsPerPage: 5, currentPage: page }">
              <td>{{s.codigo}}</td>
              <td>{{s.nombre}}</td>
              <td style="text-align: center;"><a type="button" class="fa fa-edit" data-toggle="modal" data-target="#modalEditar"
                data-bs-toggle="tooltip" data-bs-placement="right" title="editar de superintendencia"
                (click)="editarSuper(s)" style="color: green;"></a></td>
            </tr>
          </tbody>
        </table>
        <div class="row justify-content-center">
          <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
        </div>
      </div>
    </div>
  </div>
</body>

<div class="modal fade bd-example-modal-lg" id="modalEditar" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="modalEditar" style="color: white;">Editar Superintendencia</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid">
          <form>
            <div class="col-9" style="margin: auto;">
              <div class="row">
                <div class="col-4">
                  <div><label><b>Código: </b></label></div>
                  <div><input class="form-control" name="codigo" [(ngModel)]="SuperEditar.codigo"></div>
                </div>
                <div class="col-8">
                  <div><label><b>Nombre superintendencia: </b></label></div>
                  <div><input class="form-control" name="nombre" [(ngModel)]="SuperEditar.nombre"></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" style="background-color: #be0c4d;" (click)="guardarSuperEditada()">Guardar</button>
      </div>
    </div>
  </div>
</div>
